/**
 * Phase H — Flutter parity helper.
 *
 * Mirrors `_formatRoomId(s)` from `main.dart`:
 *   - Pure digit input (e.g. "5", "012") → "R#005" (zero-padded to 3 digits).
 *   - Otherwise → uppercased raw input.
 *
 * Used in two places:
 *   1. `useFilteredTables` search predicate — normalises the user query
 *      so typing "12" matches "R#012", "R#112", etc.
 *   2. Same normalisation is applied to each table's `code` before
 *      substring comparison.
 *
 * See `/app/docs/06_search_filtering.md` §3 for the parity spec.
 */
export function formatRoomId(s) {
  if (s == null) return "";
  const trimmed = String(s).trim();
  if (trimmed === "") return "";
  if (/^\d+$/.test(trimmed)) {
    const n = parseInt(trimmed, 10);
    const padded = String(n).padStart(3, "0");
    return `R#${padded}`;
  }
  return trimmed.toUpperCase();
}

/**
 * Extracts the leading integer from a table code for sort ordering.
 * "R#005" → 5; "WC-1" → 1; "RM12A" → 12; non-numeric → 0.
 */
export function extractNumber(code) {
  if (code == null) return 0;
  const m = String(code).match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 0;
}
